import React, { useState } from 'react';
import FormPanel from './FormPanel';
import PreviewPanel from './PreviewPanel';

const MainContainer = ({
  formData,
  updateFormData,
  templates,
  googleFonts,
  convertImageUrl,
  onExport,
  onPreview
}) => {
  const [activeTab, setActiveTab] = useState('models');
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const tabs = [
    { id: 'models', label: 'Modèles' },
    { id: 'general', label: 'Général' },
    { id: 'images', label: 'Images' },
    { id: 'social', label: 'Réseaux sociaux' },
    { id: 'design', label: 'Design' }
  ];

  return (
    <div className="app-body">
      <div className="tab-navigation-container">
        <button
          className="mobile-nav-toggle"
          onClick={() => setIsMobileMenuOpen((v) => !v)}
        >
          {tabs.find(t => t.id === activeTab)?.label || 'Menu'}
          <span className={`hamburger ${isMobileMenuOpen ? 'open' : ''}`}>
            <span />
            <span />
            <span />
          </span>
        </button>
        <div className={`mobile-nav ${isMobileMenuOpen ? 'open' : ''}`}>
          {tabs.map((tab) => (
            <button
              key={tab.id}
              className={`mobile-nav-item ${activeTab === tab.id ? 'active' : ''}`}
              onClick={() => {
                setActiveTab(tab.id);
                setIsMobileMenuOpen(false);
              }}
            >
              {tab.label}
            </button>
          ))}
        </div>
        <div className="tab-navigation">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              className={`tab-button ${activeTab === tab.id ? 'active' : ''}`}
              onClick={() => setActiveTab(tab.id)}
            >
              <span className="tab-label">{tab.label}</span>
            </button>
          ))}
        </div>
      </div>
      
      <div className="main-container">
        <FormPanel
          formData={formData}
          updateFormData={updateFormData}
          templates={templates}
          googleFonts={googleFonts}
          convertImageUrl={convertImageUrl}

          activeTab={activeTab}
        />
        <PreviewPanel
          formData={formData}
          onExport={onExport}
          onPreview={onPreview}
        />
      </div>
    </div>
  );
};

export default MainContainer;
